import React, { useState, useEffect } from 'react'
import Table from 'react-bootstrap/Table'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import StandingsRank from './StandingsRank'
import StandingsAngler from './StandingsAngler'
import StandingsTotal from './StandingsTotal'
import StandingsHeader from './StandingsHeader'
import StandingsFishScores from './StandingsFishScores'
import StandingsKey from './StandingsKey'
import StandingsDayTotals from './StandingsDayTotals'
import * as txApi from '../clients/tx-sls-client'


const Standings = ({tournamentId, details, user_information, hash, hideProfileLink = false, noAutoScroll = false, providedStandings = undefined}) => {
  const tournamentDetails = details
  
  //console.log('tournamentDetails found for selected tournament id::',tournamentDetails);
  //console.log('user_information value found in Standings.js:::',user_information);
  const [fullStandings, setFullStandings] = useState({
    tournamentId : '',
    days : {}
  })
  
  //const [rows, setRows] = useState(25)
  
  const [rows, setRows] = useState(175)
  
  const [standings, setStandings] = useState([])
  const [maxFish, setMaxFish] = useState(5)

  // Below code commented to allow default selection to be event total
  // Change added on 06-03-2022
  //const [currentDay, setCurrentDay] = useState(1)
  const [loading, setLoading] = useState(false)
  const [scrollTo, setScrollTo] = useState(hash)
  const [multi_single_dates, setMultiSingleDates] = useState([]);

  // Previous condition used to calculate totalDays value
  //var totalDays = tournamentDetails ? tournamentDetails.marathon_days ? tournamentDetails.marathon_days : 1 : 0

  // Check if tournament type is 3, then consider maratho_days value
  // Change added on 03-16-2021
  // This totalDays variable is used to show tab layout, if totalDays is 1, it means it is a regular,custom type tournament.
   //Naveen 26/Dec/2023::TP-349 added if condition for tourney_type 19   
  //if(tournamentDetails && tournamentDetails.tourney_type == 3 )
   if(tournamentDetails && (tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 )) ){
    var totalDays = tournamentDetails.marathon_days;
  }else{
    if(tournamentDetails &&  ( tournamentDetails.tourney_type == 12) ){
      
      var totalDays = tournamentDetails.total_tourney_days;
     
    }else if(tournamentDetails &&  ( tournamentDetails.tourney_type == 5)){
      
      var totalDays  = 2;
    }else{
      
      // For regular,custom type tournaments.  
      var totalDays = 1;
    }
  }

  // Code added to allow default selection to be event total
  // Change added on 06-03-2022
   //Naveen 26/Dec/2023::TP-349 added if condition for tourney_type 19 
   //const [currentDay, setCurrentDay] = useState(tournamentDetails && tournamentDetails.tourney_type == 3 ? '0' : 1);  
  const [currentDay, setCurrentDay] = useState(tournamentDetails && (tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 ) ) ? '0' : 1);

  console.log('totalDays output calculated:::',totalDays);


  // Check if fish records are to be hidden for user.
  // Only super-admin, director, angler as a judge should be able to see fish records even if flag value is 1
  // Change added on 01-24-2022

  // Check if logged-in user is super-admin or director
  if( ( user_information && user_information?.role === '1') || ( user_information && user_information?.user_id === tournamentDetails?.user_id )  ){

    // For super-admin, director condition
    if(tournamentDetails?.hide_fish_records === '1'){
      var hide_fish_records = 0;
    }else{
      var hide_fish_records = 0;
    }
  }else{
    // Check if logged in user is assigned as a judge
    if((tournamentDetails?.judge_list && tournamentDetails?.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( user_information && user_information?.user_id) > -1) == true ) ){

      var hide_fish_records = 0;

    }else{
      
      // Regular user, check hide_fish_records value 
      if(tournamentDetails?.hide_fish_records === '1'){
        var hide_fish_records = 1;
      }else{
        var hide_fish_records = 0;
      }
    }
  }

  const scrollToHash = (hash) => {
    if(hash && !noAutoScroll){
      window.location.hash = hash
      const target = hash.replace('#', '')
      const elem = document.getElementById(target)
      if(elem) {
        elem.scrollIntoView(true)
      }
    }
  }

  const isInViewport = (elem) => {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };


  const handleScroll = () => {
    if((!standings || standings.length === 0 || standings.length === rows) || tournamentDetails.show_standings === '0'){
      if( ( user_information && user_information.role === '1') || ( user_information && user_information.user_id === tournamentDetails.user_id )  ){

          // Do nothing, allow super-admin and tourney director to scroll through records

      }else{

          // Check if logged in user is assigned as a judge, then allow him to scroll through records

          if((tournamentDetails.judge_list && tournamentDetails.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( user_information && user_information.user_id) > -1) == true ) ){

              // Do nothing, allow judge to scroll through records

          }else{
              return;
          }

          
      } 
     
    } 

    if(isInViewport(document.querySelector('#standings-footer'))) {
      console.log(`scrolling... row value set`, rows, 'standings length response::', standings.length)
      if(standings.length < rows + 25) {
        setRows(standings.length)
      } else {
        setRows(rows => rows + 25)
      }
    }
  }

  const updateFields = (results, maxFish) => {
    setStandings(results)
    setMaxFish(maxFish) 
    //console.log('Results set for showing standings data::', results);
    //console.log('maxFish value set::',maxFish)
  }

  const handleStandings = (standings) => {
    const template = {
      tournamentId : tournamentId,
      maxFish : tournamentDetails.maxFish
    }

    const standingsResult = (standings.results.length > 1) 
      ? standings.results
      : { 1 : standings.results[0]}

    console.log('standingsResult for multi-single day tournament::', standingsResult);
    const updatedFullStandings = {...template, days : standingsResult}
      
    setFullStandings(updatedFullStandings)

    // Previous condition to assign maxFish value
    //const currentDayMaxFish = tournamentDetails.maxFish ? tournamentDetails.maxFish[currentDay-1] : 5


    // Check if tournament type is 3, if multi-day, use maxFish as array
    // Change added on 03-16-2021

    // TODO: Add team-type tourney validation and show team leaderboard/angler leaderboard
    //Naveen 26/Dec/2023::TP-349 added if condition for tourney_type 19 
    if(tournamentDetails && (tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 ) ) ){
      const currentDayMaxFish = tournamentDetails.maxFish ? tournamentDetails.maxFish[currentDay-1] : 5
      updateFields(updatedFullStandings.days[currentDay], currentDayMaxFish)
    }else{
      console.log('tournamenDetails response::', tournamentDetails);

      // Check for team-type tournament, to set the total_fish or total_fish_per_team value
      if(tournamentDetails && (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16) ){
        if(tournamentDetails.total_fish){
          const regularTourneyMaxFishPerAnglerTeamType = tournamentDetails.total_fish;
          updateFields(updatedFullStandings.days[currentDay], regularTourneyMaxFishPerAnglerTeamType)
        }else{
          const regularTourneyMaxFishPerTeamType = tournamentDetails.total_fish_per_team;
          updateFields(updatedFullStandings.days[currentDay], regularTourneyMaxFishPerTeamType)
        }
      }else{
        // Set max_fish value for regular custom field types

        const regularTourneyMaxFish = tournamentDetails.total_fish;
        updateFields(updatedFullStandings.days[currentDay], regularTourneyMaxFish)

      }

    }

    console.log('currentDay tab value passed ::', currentDay);

    console.log('hide_fish_records value passed ::', hide_fish_records);

  }

  const stopLoading = () => {
    setLoading(false)
    if(scrollTo) {
      scrollToHash(scrollTo)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [standings]);

  useEffect(() => {
    setLoading(true)
    setRows(175)

     // Get days array if tournament-type is 12
    // Change added on 03-29-2021
    if(tournamentDetails && tournamentDetails.tourney_type == 12 ){
      const check_start_date = new Date(tournamentDetails.formatted_start_date);
      const check_end_date = new Date(tournamentDetails.formatted_end_date);

      console.log('check_start_date for multi-single day tournament :::',check_start_date );
      console.log('check_end_date for multi-single day tournament :::',check_end_date );

      if(tournamentDetails && tournamentDetails.id == '17626'){
        console.log('Tournament id is 17626:::',tournamentDetails.id);
        var daysBetween = 5;
      }else{
        var daysBetween = (check_end_date.getTime() - check_start_date.getTime()) / (1000 * 3600 * 24);
      }
      

      console.log('days between start date and end date :::',daysBetween );

      const date_array = [];

      if(tournamentDetails && tournamentDetails.id == '17626'){
        for (let i = 0; i < daysBetween; i++) {

          const temp = new Date(check_start_date);
         
          temp.setDate(check_start_date.getDate() + i)
  
          date_array.push(temp);
        }
      }else{
        for (let i = 0; i <= daysBetween; i++) {

          const temp = new Date(check_start_date);
         
          temp.setDate(check_start_date.getDate() + i)
  
          date_array.push(temp);
        }
      }
      

      console.log('date_array set for multi-single day tournament:::',date_array );
      
      setMultiSingleDates(date_array);
    }

    if(fullStandings.tournamentId === tournamentId && fullStandings.days[currentDay] !== undefined) {
      console.log('using react cache')
      
      console.log('fullStandings output:::', fullStandings);

      // TODO: Add team-type tourney validation and show team leaderboard/angler leaderboard
      //Naveen 26/Dec/2023::TP-349 added if condition for tourney_type 19 
      if(tournamentDetails && (tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 ) ) ){
        var currentDayMaxFish = fullStandings.maxFish ? fullStandings.maxFish[currentDay-1] : 5
      }else{
        var currentDayMaxFish = fullStandings.maxFish ? fullStandings.maxFish[0] : 5
      }

     
     
      updateFields(fullStandings.days[currentDay], currentDayMaxFish)
      if(scrollTo) {
        scrollToHash(scrollTo)
      }
      setLoading(false)
    } else {
      if(providedStandings) {
        handleStandings(providedStandings)
        stopLoading()
      } else {
        txApi.getStandings(tournamentId)
          .then(standings => {
            handleStandings(standings);
          })
          .catch(error => {
            console.error(`Error loading standings for day ${currentDay}: ${error}`)
            setStandings([])
          })
          .finally(() => stopLoading())
      }
    }
  }, [tournamentId, currentDay, tournamentDetails])

  const createTabs = (totalDays) => {
    let tabs = []


     // Get days array if tournament-type is 12
    // Change added on 03-29-2021
    if(tournamentDetails && tournamentDetails.tourney_type == 12 ){
     
      multi_single_dates.map((date,index) => (
        tabs.push(<Tab eventKey={`${index+1}`} title={  `${date.toLocaleDateString("en-US",{weekday: "short"})} - ${ date.toLocaleDateString("en-US",{day: "2-digit"}) } ` }></Tab>)
      ))

      // Code added to allow default selection to be event total
      // Change added on 06-03-2022
      tabs.push(<Tab eventKey="0" title='Total'></Tab>)
    }else if(tournamentDetails && (tournamentDetails.tourney_type == 3 || ( tournamentDetails.tourney_type == 19  && tournamentDetails.is_fish_count_per_event != 1 ) ) ){
      //Naveen 26/Dec/2023::TP-349 added if condition for tourney_type 19 
      // Code added to allow default selection to be event total .// Change added on 06-03-2022
     //Fix client reported issue- " when click on Day 1, Day2 ,Day3., the leaderboard page jumps around. The page should stay still and only the leaderboard change."  Added //document.void() in anchor tag  currently removed    eventKey={`javascript:void()${day}`}
      tabs.push(<Tab eventKey="0" title='Total'><a href={`${day}`} onClick={(e) => e.preventDefault()}>
          {/* Content of your tab */}
        </a></Tab>)
      for(var day = 1; day <= totalDays; day++) {
       // tabs.push(<Tab eventKey={`${day}`} title={`Day ${day}`}></Tab>)
          tabs.push(<Tab eventKey={`${day}`} title={`Day ${day}`}>
            <a href={`${day}`} onClick={(e) => e.preventDefault()}>
          {/* Content of your tab */}
        </a></Tab>)
      }
    }else if(tournamentDetails && tournamentDetails.tourney_type == 5){

      for(var day = 1; day <= totalDays; day++) {
        tabs.push(<Tab eventKey={`${day}`} title={`Day ${day}`}></Tab>)
      }
      tabs.push(<Tab eventKey="0" title='Total'></Tab>)
    }

    //Previous commented code for showing total tab at the last section
    // Code commented on 06-03-2022
    //tabs.push(<Tab eventKey="0" title='Total'></Tab>)

    return tabs
  }

  return (
  <>
    <div className='standings-link'><a id="scores" name="scores"/></div>    
    { loading 
      ? <div className="loading" /> 
      : 
      

      // Check if standings data is present, else show No submissions message
      // Change added on 03-16-2021

      <div>

      { 
        (totalDays > 1) ?
        <Tabs id="tabs" activeKey={currentDay}  onSelect={d => {setCurrentDay(d);setScrollTo(`#scores`)}}>
          {createTabs(totalDays)}
        </Tabs>
        : <div></div>
      }

      <div className="d-sm-none">

      {
          // Check if standings record is present, then only show the standings data, else show No submissions to show message
          (standings && standings.length > 0 ) ? 
          <StandingsKey anglers={standings ? standings.length : 0} fishCaught={tournamentDetails?.total_fish_caught} hide_fish_records={hide_fish_records}  />
          :  <h5 className="no-show">No Submissions To Show</h5>
      }

      {
        (standings && standings.length > 0 ) ? 
        <Table responsive hover>
        <StandingsHeader numberOfFish={maxFish} hideFish='true' days={totalDays} day={currentDay} hide_fish_records={hide_fish_records} />
          <tbody>
            {
              standings ? standings.slice(0,rows).map((standing, index) => 
              <>
              
                <tr  className="standing-mobile-view-user-list" id={standing?.user_id}>
                  <StandingsRank rank={index+1} key={`rank${index}`} />
                
                  <StandingsAngler angler={standing} user_information={user_information} key={`angler${index}`}  hideProfileLink={hideProfileLink} is_basscat_tourney = {tournamentDetails.is_basscat_tourney}/>
                  
                  <StandingsTotal showDropdown='true' total_length={standing.total_fish_length ? standing.total_fish_length : 0} total_weight={standing.total_fish_weight ? standing.total_fish_weight : 0} day_wise_fish_records = { standing.day_wise_fish_records } culled_fish_records = { standing.culled_fish_records } tourney_type = {tournamentDetails.tourney_type} fish_caught = {standing.fish_caught}  top_max_fish_length={standing.top_max_fish_length} top_max_fish_weight={standing.top_max_fish_weight} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} scoresId={'scores'+index} estimated_total_fish_weight = {standing?.estimated_total_fish_weight ? standing.estimated_total_fish_weight : ''} hide_fish_records={hide_fish_records} key={`total${index}`} total_of_day_wise_fish_count={standing.total_of_day_wise_fish_count} show_multi_day_fish_count = {tournamentDetails.show_multi_day_fish_count} total_fish_points = {standing.total_fish_points ? standing.total_fish_points : 0} show_points={tournamentDetails.use_walleye_conversion}/>
                  
                </tr>
                <tr id={'scores'+index} className='hidden standings-fish-score-table'>
                  <td colSpan='3'>
                  <Table key={`scoresRow${index}`}>
                    <tbody>
                      <tr id={standing?.user_id}>
                            
                      { 
                          (tournamentDetails.tourney_type == 12 && multi_single_dates ) ?

                          currentDay === '0' 
                          ?  //Naveen 30/Jan/2024::TP-349 added condition to get tournament per event/day type
                          <StandingsDayTotals submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type}  days={totalDays} key={`lgdaytotals${index}`} showPrefix={true} showDayPrefix='true' tourney_type={tournamentDetails.tourney_type}   day_array= {multi_single_dates} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} show_multi_day_fish_count = {tournamentDetails.show_multi_day_fish_count} colspan='3'/>
                          : <StandingsFishScores tournament_event_type={tournamentDetails.is_fish_count_per_event} submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} user_information={user_information} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} key={`score${index}`} colSpan='3'/>
                          :
                          currentDay === '0' 
                          ?  //Naveen 30/Jan/2024::TP-349 added condition to get tournament per event/day type
                          //TP-400 Jira card :: Added values from API - show_multi_day_fish_count, fish_record_result
                          <StandingsDayTotals submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type}  days={totalDays} tourney_type={tournamentDetails.tourney_type} key={`lgdaytotals${index}`} showPrefix={true} showDayPrefix='true' length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} show_multi_day_fish_count = {tournamentDetails.show_multi_day_fish_count} fish_record_result = {standing.fish_record_result} colspan='3'/>
                          : <StandingsFishScores tournament_event_type={tournamentDetails.is_fish_count_per_event} submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} user_information={user_information} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} hide_fish_records={hide_fish_records} key={`score${index}`} colSpan='3'/>
                      }    
                        
                      </tr>
                    </tbody>
                  </Table>
                  </td>
                </tr>
                </>
              ) : <tr><td colSpan='3'></td></tr>
            }

          </tbody>
        </Table>
        :
        
        null // No standings data found else condition

      }
       
      </div>

      
      <div className="d-none d-sm-block">
        
      {
              // Check if standings record is present, then only show the standings data, else show No submissions to show message
              (standings && standings.length > 0 ) ? 
              <StandingsKey anglers={standings ? standings.length : 0 } fishCaught={tournamentDetails.total_fish_caught} hide_fish_records={hide_fish_records}  /> 
              : <h5 className="no-show">No Submissions To Show</h5>
      }
      { 

        (standings && standings.length > 0 ) ? 
        <Table responsive hover striped>
           {
             (tournamentDetails.tourney_type == 12 && multi_single_dates ) ?
             <StandingsHeader numberOfFish={maxFish} showDays={currentDay === '0'} days={totalDays} day={currentDay} tourney_type={tournamentDetails.tourney_type}  day_array= {multi_single_dates} /> 
             :
             <StandingsHeader numberOfFish={maxFish} showDays={currentDay === '0'} days={totalDays} day={currentDay} hide_fish_records={hide_fish_records}/> 

           }

           <tbody>
            {
              
              standings ? standings.slice(0,rows).map((standing, index) => 
            
                <tr className="standing-user-list" id={standing?.user_id}>
                  <StandingsRank rank={index+1} key={`lgrank${index}`}/>
                  
                  <StandingsAngler tournamentType={tournamentDetails.tourney_type} angler={standing}  user_information={user_information} key={`lgangler${index}`}  hideProfileLink={hideProfileLink} is_basscat_tourney = {tournamentDetails.is_basscat_tourney}/>
                
                  { 
                     
                      currentDay === '0' ? 
                      //TP-400 Jira card :: Added values from API - show_multi_day_fish_count, fish_record_result
                      <StandingsDayTotals submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} days={totalDays} tourney_type={tournamentDetails.tourney_type} key={`lgdaytotals${index}`} showPrefix={true} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} show_multi_day_fish_count = {tournamentDetails.show_multi_day_fish_count} fish_record_result = {standing.fish_record_result} colspan='3'/>
                      
                      : 
                      //Naveen 30/Jan/2024::TP-349 added condition to get tournament per event/day type
                      <StandingsFishScores  tournament_event_type={tournamentDetails.is_fish_count_per_event} submissions={standing.submissions} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} user_information={user_information} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} hide_fish_records={hide_fish_records} key={`score${index}`} colSpan='3'/>
                  }
                  
                  <StandingsTotal total_length={standing.total_fish_length ? standing.total_fish_length : 0} total_weight={standing.total_fish_weight ? standing.total_fish_weight : 0} day_wise_fish_records = { standing.day_wise_fish_records  } culled_fish_records = { standing.culled_fish_records } tourney_type = {tournamentDetails.tourney_type} fish_caught = {standing.fish_caught} top_max_fish_length={standing.top_max_fish_length} top_max_fish_weight={standing.top_max_fish_weight} measurement_type= {tournamentDetails.measurement_type} maxFish={maxFish} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} estimated_total_fish_weight = {standing?.estimated_total_fish_weight ? standing.estimated_total_fish_weight : ''} hide_fish_records={hide_fish_records} key={`total${index}`} total_of_day_wise_fish_count={standing.total_of_day_wise_fish_count} show_multi_day_fish_count = {tournamentDetails.show_multi_day_fish_count} total_fish_points = {standing.total_fish_points ? standing.total_fish_points : 0} show_points={tournamentDetails.use_walleye_conversion}/>
                </tr>
              
              ) : <tr><td colSpan={maxFish + 3}></td></tr>
              
              
            }

          </tbody>
        

        </Table>

        : null //Standings data not found, send null response

      }
       

      </div>
      </div>

     
     
     
    }

      <div id='standings-footer' />

</>
  
)}

export default Standings